<template>
	<div class="modal fade modal-fullscreen" id="createTaskModal" role="dialog" aria-labelledby="detailsPersonModalLabel" aria-hidden="true">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header mt-3 mb-0">
					<h5 class="modal-title" id="detailsPersonModalLabel">{{$t('buttons.relatedRecords.tooltipText')}}</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body" v-if="showRelatedRecords">
					<form-summary-grid
                        :formToRegisterEntityId="formToRegisterEntityId"
                        :showPager="false">
					</form-summary-grid>
				</div>
				<div class="modal-footer">
					<div class="btn-group" role="group" aria-label="Control buttons">
						<button type="button" class="btn btn-danger" @click.stop="onClose">
							<i class="fas fa-times mr-2"></i>
							{{ $t('buttons.close')}}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import FormSummaryGrid from './FormSummaryGrid';

export default {
	components: {
		FormSummaryGrid
	},
	props: {
		value: {
			required: false
		},
		show: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			showRelatedRecords: false,
			formToRegisterEntityId: 0
		};
	},
	methods: {
		onClose() {
			this.$emit('onClose', { ...this.model });
			this.showRelatedRecords = false;
			this.formToRegisterEntityId = 0;
		},
		hide() {
			$(this.$el).modal('hide');
		}
	},
	mounted() {
		// add modal close listener
		$(this.$el).on('hidden.bs.modal', this.onClose);
	},
	beforeDestroy() {
		// remove listener
		$(this.$el).off('hidden.bs.modal');
	},
	watch: {
		show: function(val) {
			if (val) {
				let num = Number(this.value);
				if (!isNaN(num) && num > 0) {
					this.formToRegisterEntityId = this.value;
					this.showRelatedRecords = true;
					$(this.$el).modal('show');
				}
			} else {
				$(this.$el).modal('hide');
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.bmd-form-group {
	padding-top: 0px !important;
}

.modal.modal-fullscreen .modal-dialog {
    width: 100vw;
    height: 100vh;
    margin: 0;
    padding: 0;
    max-width: none;
}

.modal.modal-fullscreen .modal-content {
    height: auto;
    height: 100vh;
    border-radius: 0;
    border: none;
}

.modal.modal-fullscreen .modal-body {
    overflow-y: auto;
}
</style>
